const PIN_INFO = 'index/PIN_INFO' as const;
const SET_PIN_INFO = 'index/SET_PIN_INFO' as const;
export const getPinInfo = () => ({
  type: PIN_INFO,
});

export const setPinInfo = (state: PinState) => ({
  type: SET_PIN_INFO,
  payload: state,
});

type PinAction = ReturnType<typeof getPinInfo> | ReturnType<typeof setPinInfo>;

export type PinState = {
  pinNum: string;
  path: string;
  active: boolean;
};
const initialState: PinState = {
  pinNum: '',
  path: '',
  active: false
};

function pin(state: PinState = initialState, action: PinAction): any {
  switch (action.type) {
    case PIN_INFO:
      return { ...state };
    case SET_PIN_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default pin;
